import * as t from "io-ts";
import { FinanceProvider } from "./FinanceProvider";
import { FinanceRate } from "./FinanceRate";
import { WorkType } from "./WorkType";

export const InfoWorkType = t.intersection([
  t.type({
    product: t.string,
    work_type: WorkType,
    rates: t.array(FinanceRate),
  }),
  t.partial({
    primary: FinanceProvider,
  }),
]);

export interface InfoWorkType {
  product: string;
  work_type: WorkType;
  primary?: FinanceProvider;
  rates: Array<FinanceRate>;
}
